import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import HomeFooter from "./HomeFooter";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from './Config';
import NotificationExample, { notify } from './NotificationExample';
import LoadingN from './Loader';
import axios from 'axios';

const Address = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [pincode, setPincode] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [localities, setLocalities] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState('');
  const [error, setError] = useState('');

  // Function to load data from localStorage on component mount
  useEffect(() => {
    const reg_id = localStorage.getItem('regid');
    if (reg_id) {
    
      const savedData =localStorage.getItem('pincode');
      if (savedData!="null") {
        setPincode(localStorage.getItem('pincode') || '');
        setCity(localStorage.getItem('city') || '');
        setState(localStorage.getItem('state') || '');
        setSelectedLocality(localStorage.getItem('block') || '');
        getLocation(localStorage.getItem('pincode'));
      }
    }
  }, []);

  const handlePincodeChange = async (event) => {
    setPincode(event.target.value);
    if (event.target.value.length === 6) {
      await getLocation(event.target.value);
    }
  };
 
  const getLocation = async (pincode) => {
   
    try {
      setLoading(true);
      const response = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          address: pincode,
          key: 'AIzaSyCYwoaLUyvr9Z5r9Xzw0OkZ6e7EIswM3NY'
        }
      });

      if (response.data.status === 'OK') {
        const result = response.data.results[0];
        const addressComponents = result.address_components;

        const cityComponent = addressComponents.find(component =>
          component.types.includes('locality')
        );
        const cityComponent2 = addressComponents.find(component =>
          component.types.includes('administrative_area_level_3')
        );
        const cityComponent1 = addressComponents.find(component =>
          component.types.includes('administrative_area_level_2')
        );
        const stateComponent = addressComponents.find(component =>
          component.types.includes('administrative_area_level_1')
        );
        if(cityComponent2)
        {
          setCity(cityComponent2.long_name);
        }else{
          setCity(cityComponent ? cityComponent.long_name : cityComponent1.long_name);
        }
     
        setState(stateComponent ? stateComponent.long_name : '');
        setLocalities(result.postcode_localities || []);
        setError(null);
        setLoading(false);
      } else {
        setError('Please enter a valid 6-digit pincode.');
        setCity('');
        setState('');
        setLocalities([]);
        setLoading(false);
      }
    } catch (error) {
      setError('Kindly enter your pincode.');
      setCity('');
      setState('');
      setLocalities([]);
      setLoading(false);
    }
  };

  const handleLocalityChange = (event) => {
    setSelectedLocality(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const reg_id = localStorage.getItem('regid');
    if(state=="")
    {
      setError('Location not found for provided pincode.');
      setLoading(false);
     return false;
    }
    try {
      const response = await axios.post(`${API_BASE_URL}/cpanel/saveProfileDataaddress`, {
        pincode,
        city,
        state,
        locality: selectedLocality,
        reg_id
      });
      const result = response.data;
      if (result.Status) {
        localStorage.setItem('pincode',pincode);
        notify('success', 'Profile updated successfully');
        navigate('/Completeprofile');
      } else {
        navigate('/Completeprofile');
       // notify('error', result.message);
      }
    } catch (error) {
      notify('error', 'Error submitting profile data');
    } finally {
      setLoading(false);
    }
  };

  // Save data to localStorage whenever state changes
  useEffect(() => {
    localStorage.setItem('addressData', JSON.stringify({ pincode, city, state, locality: selectedLocality }));
  }, [pincode, city, state, selectedLocality]);

  return (
    <>
      <NotificationExample />
      <div>
        <div className="header-area" id="headerArea">
          <div className="container">
            <div className="header-content position-relative d-flex align-items-center justify-content-between">
              <div className="back-button">
                <Link to="/Changeprofile">
                  <i className="bi bi-arrow-left-short"></i>
                </Link>
              </div>
              <div className="page-heading">
                <h2 className="mb-0">Address</h2>
              </div>
              <div className="setting-wrapper">
                <Link to="/Language">
                  <i className="bi bi-gear"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content-wrapper py-3">
        <div className="container">
          <div className="element-heading">
            <h6>Your Location</h6>
          </div>
        </div>
        {loading && <LoadingN />}
        <div className="container">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label" htmlFor="pincode">Pin Code</label>
                  <input
                    className="form-control"
                    id="pincode"
                    type="text"
                    value={pincode}
                    onChange={handlePincodeChange}
                    maxLength="6"
                    required
                  />
                  <p style={{marginTop:'5px',color:'#8b5f5f'}}>{error}</p>
                </div>
                {city !== "" &&
                  <>
                    <div className="form-group">
                      <label className="form-label" htmlFor="state">State</label>
                      <input
                        className="form-control"
                        id="state"
                        type="text"
                        value={state}
                        readOnly
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label" htmlFor="city">City</label>
                      <input
                        className="form-control"
                        id="city"
                        type="text"
                        value={city}
                        readOnly
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Block / Village / Localities</label>
                      <select
                        className="form-control"
                        value={selectedLocality}
                        onChange={handleLocalityChange}
                    
                      >
                        <option value="">
                          Block / Village / Localities
                        </option>
                        {localities.map((locality, index) => (
                          <option key={index} value={locality}>
                            {locality}
                          </option>
                        ))}
                      </select>
                    </div>
                  </>
                }
                <button type="submit" className="btn btn-primary w-100 d-flex align-items-center justify-content-center">
                  Update Profile <i className="bi bi-arrow-right fz-16 ms-1"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <HomeFooter />
    </>
  );
};

export default Address;
